import React from 'react';
import { Line } from 'react-chartjs-2';

const StackedColourGraph = ({ series, className }) => {
	const labels = series
		.map((category) => category.dataset.map((series) => series.label))
		.flat()
		.filter((value, index, self) => self.indexOf(value) === index);
	const formattedData = {
		labels,
		datasets: series.map(({ label, dataset, backgroundColor }) => {
			return {
				label,
				backgroundColor,
				borderColor: backgroundColor,
				lineTension: 0,
				cubicInterpolationMode: 'monotone',
				pointRadius: 0,
				pointHitRadius: 4,
				data: labels.map((label) => dataset.find((d) => d.label === label).value)
			};
		})
	};

	let options = {
		responsive: true,
		spanGaps: true,
		maintainAspectRatio: false,
		gridLines: {
			display: false,
			zeroLineWidth: 0
		},
		tooltips: {
			mode: 'index',
			intersect: false
		},
		legend: {
			display: false
		},
		scales: {
			xAxes: [
				{
					stacked: true,
					display: false
				}
			],
			yAxes: [
				{
					stacked: true
				}
			]
		}
	};

	return <Line className={className} data={formattedData} options={options} />;
};

export default StackedColourGraph;
